<template>
    <div class="c-app">
        <TheSidebar />
        <CWrapper>
            <TheHeader @refreshView="actualizarVista" />
            <div class="c-body">
                <main class="c-main">
                    <CContainer fluid>

                        <transition name="fade" mode="out-in">
                            <router-view :key="`${$route.path}-${refreshKey}`"></router-view>
                        </transition>
                    </CContainer>
                </main>
            </div>
            <TheFooter />
        </CWrapper>
        <!--aqui el right sidebar-->
        <HistoricoDocumentos />
    </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'

import HistoricoDocumentos from './Componentes/HistoricoDocumentos.vue'

export default {
    name: 'TheContainer',
    components: {
        TheSidebar,
        TheHeader,
        TheFooter,
        HistoricoDocumentos
    },
    data() {
        return {
            refreshKey: 0,
        }
    },
    beforeMount() {
        let cookieUsername = this.$cookie.get('userLogginToken')
        if (cookieUsername === null || cookieUsername === "") {
            this.$router.push("/pages/login");
        }


    },
    methods: {
        actualizarVista: function () {
            this.refreshKey += 1
        }

    }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
